import { NgModule } from '@angular/core';
import { NgxZeroStateComponent } from '@go-modules/components/zero-state/zero-state.component';

@NgModule({
	declarations: [
		NgxZeroStateComponent
	],
	exports: [
		NgxZeroStateComponent
	]
})
export class NgxZeroStateModule {}
